import React from "react";
import { Link } from "react-router-dom";

const courseCategories = {
  tk: [
    {
      title: "Belajar Calistung TK/PAUD",
      subject: "TK/PAUD",
      duration: "1,5 Jam",
      capacity: "1-3 Siswa",
      image: "assets/images/thumbs/tk-program.jpg",
    },
    {
      title: "Mengaji, BTA dan Bahasa Inggris",
      subject: "TK/PAUD",
      duration: "1,5 Jam",
      capacity: "1-3 Siswa",
      image: "assets/images/thumbs/tk-program.jpg",
    },
  ],
  sd: [
    {
      title: "Les Privat SD",
      subject: "SD",
      duration: "1,5 Jam",
      capacity: "1-3 Siswa",
      image: "assets/images/thumbs/sd-math.jpg",
    },
    {
      title: "Les Privat Olimpiade SD/MI",
      subject: "SD/MI",
      duration: "1,5 Jam",
      capacity: "Privat 1 Guru 1 Siswa",
      image: "assets/images/thumbs/sd-math.jpg", 
      description: `Bimbingan khusus untuk meningkatkan kemampuan belajar persiapan menghadapi kejuaraan kompetisi olimpiade tingkat kabupaten, provinsi, nasional dan internasional.
      
Materi: Matematika dan Ilmu Pengetahuan Alam
- Guru datang ke rumah siswa (Privat 1 Guru 1 Siswa)
- Pendekatan belajar untuk siswa SD/MI diajari sampai siswa bisa dan paham secara mendetail
- Bisa disiapkan mulai kelas 3 SD/MI
- Biaya Rp.80.000,-/pertemuan selama 1,5 Jam`,
    },
  ],
  smp: [
    {
      title: "Les Privat SMP",
      subject: "SMP",
      duration: "1,5 Jam",
      capacity: "1-3 Siswa",
      image: "assets/images/thumbs/sma-math.jpg",
    },
    {
      title: "Les Privat SMP IPA",
      subject: "SMP",
      duration: "1,5 Jam",
      capacity: "1-3 Siswa",
      image: "assets/images/thumbs/sma-math.jpg",
    },
    {
      title: "Les Privat SMP Bahasa Inggris",
      subject: "SMP",
      duration: "1,5 Jam",
      capacity: "1-3 Siswa",
      image: "assets/images/thumbs/sma-math.jpg",
    },
    {
      title: "Les Privat Olimpiade SMP/MTS",
      subject: "SMP/MTS",
      duration: "1,5 Jam",
      capacity: "Privat 1 Guru 1 Siswa",
      image: "assets/images/thumbs/sma-math.jpg", 
      description: `Bimbingan khusus untuk meningkatkan kemampuan belajar persiapan menghadapi kejuaraan kompetisi olimpiade tingkat kabupaten, provinsi, nasional dan internasional.

Materi: Matematika, Fisika, Biologi, IPS
- Guru datang ke rumah siswa (Privat 1 Guru 1 Siswa)
- Pendekatan belajar untuk siswa SMP/MTS diajari sampai siswa bisa dan paham secara mendetail
- Bisa disiapkan mulai kelas 1 SMP/MTS
- Biaya Rp.90.000,-/pertemuan selama 1,5 Jam`,
    },
  ],
  sma: [
    {
      title: "Les Privat SMA Matematika",
      subject: "SMA",
      duration: "1,5 Jam",
      capacity: "1-3 Siswa",
      image: "assets/images/thumbs/smp-math.jpg",
    },
    {
      title: "Les Privat SMA Fisika",
      subject: "SMA",
      duration: "1,5 Jam",
      capacity: "1-3 Siswa",
      image: "assets/images/thumbs/smp-math.jpg",
    },
    {
      title: "Les Privat SMA Kimia",
      subject: "SMA",
      duration: "1,5 Jam",
      capacity: "1-3 Siswa",
      image: "assets/images/thumbs/smp-math.jpg",
    },
    {
      title: "Les Privat Olimpiade SMA/MA/SMK",
      subject: "SMA/MA/SMK",
      duration: "1,5 Jam",
      capacity: "Privat 1 Guru 1 Siswa",
      image: "assets/images/thumbs/olimpiade.jpg", // Pastikan gambar tersedia
      description: `Bimbingan khusus untuk meningkatkan kemampuan belajar persiapan menghadapi kejuaraan kompetisi olimpiade tingkat kabupaten, provinsi, nasional dan internasional.

Materi: Matematika, Fisika, Biologi, Kimia, Astronomi, Komputer, Ekonomi, Kebumian, Geografi
- Guru datang ke rumah siswa (Privat 1 Guru 1 Siswa)
- Pendekatan belajar untuk siswa SMA/MA/SMK diajari sampai siswa bisa dan paham secara mendetail
- Bisa disiapkan mulai kelas 1 SMA/MA/SMK
- Biaya Rp.100.000,-/pertemuan selama 1,5 Jam`,
    },
  ],
  umum: [
    {
      title: "Kursus TOEFL Preparation",
      subject: "Umum",
      duration: "1,5 Jam",
      capacity: "1-3 Siswa",
      image: "assets/images/thumbs/toefl.jpg",
    },
    {
      title: "Les Privat Bahasa Inggris",
      subject: "Umum",
      duration: "1,5 Jam",
      capacity: "1-3 Siswa",
      image: "assets/images/thumbs/english.jpg",
    },
    {
      title: "Bimbel Intensif UTBK SBMPTN UM",
      subject: "Umum",
      duration: "1,5 Jam",
      capacity: "1-3 Siswa",
      image: "assets/images/thumbs/99.jpg",
      description: `Program bimbingan belajar intensif persiapan UTBK SBMPTN UM khusus bagi kamu yang duduk di kelas 12 SMA/MA/SMK, atau pejuang PTN yang baru lulus, gapyear, atau sudah kuliah di universitas lain, tapi masih mau memperjuangkan PTN impianmu.

Fasilitas:
- Guru datang ke rumah siswa
- Bimbingan interaktif (1 Guru 1 Siswa)
- Informasi Passing Grade
- Strategi dan tips trik lolos PTN
- Materi: Kemampuan Bahasa, Kemampuan Verbal, Kemampuan Penalaran, Kemampuan Aritmatika, Aljabar, Statistika, Geometri
- Biaya hanya Rp.100.000,- per pertemuan (Pembelajaran 1,5 Jam, siswa diajari sampai paham dan bisa)
- Tutor ramah dan berpengalaman`
    },
    {
      title: "Les Privat TPA (Tes Potensi Akademik)",
      subject: "Umum",
      duration: "1,5 Jam",
      capacity: "1-3 Siswa",
      image: "assets/images/thumbs/98.jpg", 
      description: `Persiapan tes untuk lolos beasiswa, syarat S2/S3, tes masuk PKN STAN, CPNS, dll.

Materi:
- Tes Sinonim, Antonim dan Kosakata
- Tes Analogi
- Bacaan
- Aritmatika
- Logika
- Pola Barisan

Biaya Rp.100.000,-/per pertemuan`
    },
  ],
};

const CourseCard = ({ course }) => {
  return (
    <div className="course-item bg-white rounded-16 p-12 box-shadow-md transition-03 hover-border-main-600 border item-hover">
      <div className="course-item__thumb rounded-12 overflow-hidden position-relative">
        <Link to="/program-details" className="w-100 h-100">
          <img
            src={course.image}
            alt={course.title}
            className="course-item__img rounded-12 cover-img transition-2"
          />
        </Link>
      </div>
      <div className="course-item__content position-relative">
        <div className="">
          <div className="mb-16 flex-align gap-16 flex-wrap">
            <Link
              to="/program"
              className="py-4 px-12 rounded-8 flex-align gap-8 text-main-three-600 fw-medium bg-main-three-25 hover-bg-main-three-600 hover-text-white border border-success-200"
            >
              <span className="md">{course.subject}</span>
            </Link>
          </div>
          <div className="d-flex gap-24 flex-wrap mb-16">
            <div className="flex-align gap-8">
              <span className="text-neutral-700 text-lg d-flex">
                <i className="ph-bold ph-clock" />
              </span>
              <span className="text-neutral-700 text-md fw-normal">
                {course.duration}
              </span>
            </div>
            <div className="flex-align gap-8">
              <span className="text-neutral-700 text-lg d-flex">
                <i className="ph-bold ph-user-circle" />
              </span>
              <span className="text-neutral-700 text-md fw-normal">
                {course.capacity}
              </span>
            </div>
          </div>
          <h4 className="mb-28">
            <Link to="/program-details" className="link text-line-2">
              {course.title}
            </Link>
          </h4>
        </div>
        <div className="flex-between gap-8 pt-24 border-top border-neutral-50 mt-28 border border-0">
          <div>
            <div className="mb-8">
              <span className="text-md fw-medium">Guru Professional</span>
            </div>
            <span>Sistem Home Tutoring</span>
          </div>
          <Link to="https://docs.google.com/forms/d/e/1FAIpQLSfzvXXZGbqg8lm40M-ix6RNF-RV-cgK3KLJl9gn_9ERi_0FsQ/viewform" className="btn btn-main btn-sm">
            Daftar Sekarang
          </Link>
        </div>
      </div>
    </div>
  );
};

const TabContent = ({ courses }) => {
  return (
    <div className="row gy-4">
      {courses.map((course, index) => (
        <div
          key={index}
          className="col-lg-4 col-sm-6 wow fadeInUp"
          data-aos="fade-up"
          data-aos-duration={600 + index * 100}
        >
          <CourseCard course={course} />
        </div>
      ))}
    </div>
  );
};

const ExploreCourseThree = () => {
  return (
    <section className="explore-course py-120 bg-main-25 position-relative z-0">
      <div className="position-absolute start-0 top-0 w-100 z-index-n9">
        <img
          src="assets/images/shapes/cloud-shap-img2.png"
          alt=""
          className="w-100 z-n9"
        />
      </div>
      <div className="container ">
        <div className="max-w-611 text-center mx-auto mb-60">
          <div
            className="text-main-600 fw-semibold text-xl d-flex align-items-center gap-8 mb-16 justify-content-center flex-wrap"
            data-aos="fade-down"
          >
            <span>
              <i className="ph-bold ph-book" />
            </span>
            <span>Program Les Privat</span>
          </div>
          <h2 className="mb-24 wow bounceIn">Pilihan Program Belajar</h2>
          <p className="max-w-557-px text-md text-neutral-700 fw-normal wow bounceInUp">
            Bimbel Kusuma menyediakan berbagai program belajar untuk semua
            jenjang pendidikan dengan sistem guru datang ke rumah
          </p>
        </div>
        <div className="text-center">
          <div
            className="nav-tab-wrapper bg-white p-16 mb-40 d-inline-block"
            data-aos="zoom-out"
          >
            <ul
              className="nav nav-pills common-tab gap-16"
              id="pills-tab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link rounded-pill bg-main-25 text-md fw-medium text-neutral-500 flex-center w-100 gap-8 active"
                  id="pills-all-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-all"
                  type="button"
                  role="tab"
                  aria-controls="pills-all"
                  aria-selected="true"
                >
                  <i className="text-xl d-flex ph-bold ph-squares-four" />
                  Semua Program
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link rounded-pill bg-main-25 text-md fw-medium text-neutral-500 flex-center w-100 gap-8"
                  id="pills-tk-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-tk"
                  type="button"
                  role="tab"
                  aria-controls="pills-tk"
                  aria-selected="false"
                >
                  <i className="text-xl d-flex ph-bold ph-baby" />
                  TK/PAUD
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link rounded-pill bg-main-25 text-md fw-medium text-neutral-500 flex-center w-100 gap-8"
                  id="pills-sd-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-sd"
                  type="button"
                  role="tab"
                  aria-controls="pills-sd"
                  aria-selected="false"
                >
                  <i className="text-xl d-flex ph-bold ph-student" />
                  SD
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link rounded-pill bg-main-25 text-md fw-medium text-neutral-500 flex-center w-100 gap-8"
                  id="pills-smp-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-smp"
                  type="button"
                  role="tab"
                  aria-controls="pills-smp"
                  aria-selected="false"
                >
                  <i className="text-xl d-flex ph-bold ph-books" />
                  SMP
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link rounded-pill bg-main-25 text-md fw-medium text-neutral-500 flex-center w-100 gap-8"
                  id="pills-sma-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-sma"
                  type="button"
                  role="tab"
                  aria-controls="pills-sma"
                  aria-selected="false"
                >
                  <i className="text-xl d-flex ph-bold ph-graduation-cap" />
                  SMA/SMK
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link rounded-pill bg-main-25 text-md fw-medium text-neutral-500 flex-center w-100 gap-8"
                  id="pills-umum-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-umum"
                  type="button"
                  role="tab"
                  aria-controls="pills-umum"
                  aria-selected="false"
                >
                  <i className="text-xl d-flex ph-bold ph-users-three" />
                  Umum
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-all"
            role="tabpanel"
            aria-labelledby="pills-all-tab"
          >
            <TabContent
              courses={[
                ...courseCategories.tk,
                ...courseCategories.sd,
                ...courseCategories.smp,
                ...courseCategories.sma,
                ...courseCategories.umum,
              ]}
            />
          </div>
          <div
            className="tab-pane fade"
            id="pills-tk"
            role="tabpanel"
            aria-labelledby="pills-tk-tab"
          >
            <TabContent courses={courseCategories.tk} />
          </div>
          <div
            className="tab-pane fade"
            id="pills-sd"
            role="tabpanel"
            aria-labelledby="pills-sd-tab"
          >
            <TabContent courses={courseCategories.sd} />
          </div>
          <div
            className="tab-pane fade"
            id="pills-smp"
            role="tabpanel"
            aria-labelledby="pills-smp-tab"
          >
            <TabContent courses={courseCategories.smp} />
          </div>
          <div
            className="tab-pane fade"
            id="pills-sma"
            role="tabpanel"
            aria-labelledby="pills-sma-tab"
          >
            <TabContent courses={courseCategories.sma} />
          </div>
          <div
            className="tab-pane fade"
            id="pills-umum"
            role="tabpanel"
            aria-labelledby="pills-umum-tab"
          >
            <TabContent courses={courseCategories.umum} />
            <div className="mt-40 animate__animated animate__fadeIn">
              <div className="text-center mb-24">
                <i
                  className="ph-bold ph-lightbulb text-warning-600"
                  style={{
                    fontSize: 48,
                    animation: "spin 2s linear infinite",
                  }}
                />
                <h4 className="mt-16 mb-8 fw-semibold text-main-600">
                  Pilihan Program Umum
                </h4>
                <p className="text-neutral-700">
                  Berikut beberapa program populer di kategori Umum Bimbel
                  Kusuma:
                </p>
              </div>
              <ul
                className="list-group list-group-flush mx-auto"
                style={{ maxWidth: 420 }}
              >
                <li className="list-group-item d-flex align-items-center gap-16">
                  <i className="ph ph-medal text-success-600 text-2xl" />
                  <span>UTBK (Ujian Tulis Berbasis Komputer)</span>
                </li>
                <li className="list-group-item d-flex align-items-center gap-16">
                  <i className="ph ph-trophy text-warning-600 text-2xl" />
                  <span>OSN (Olimpiade Sains Nasional)</span>
                </li>
                <li className="list-group-item d-flex align-items-center gap-16">
                  <i className="ph ph-file-text text-info-600 text-2xl" />
                  <span>TPA (Tes Potensi Akademik)</span>
                </li>
                <li className="list-group-item d-flex align-items-center gap-16">
                  <i className="ph ph-book-open text-main-600 text-2xl" />
                  <span>Bahasa Inggris Dasar</span>
                </li>
                <li className="list-group-item d-flex align-items-center gap-16">
                  <i className="ph ph-globe-hemisphere-east text-primary-600 text-2xl" />
                  <span>TOEFL Preparation</span>
                </li>
                <li className="list-group-item d-flex align-items-center gap-16">
                  <i className="ph ph-globe-hemisphere-west text-primary-600 text-2xl" />
                  <span>IELTS Preparation</span>
                </li>
                <li className="list-group-item d-flex align-items-center gap-16">
                  <i className="ph ph-pencil-simple text-danger-600 text-2xl" />
                  <span>Karya Tulis Ilmiah</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="position-absolute start-0 bottom-0 w-100 z-index-n9">
        <img
          src="assets/images/shapes/cloud-shap-img1.png"
          alt=""
          className="w-100"
        />
      </div>
    </section>
  );
};

export default ExploreCourseThree;
